import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { TableModule, TableRowSelectEvent } from 'primeng/table';
import { PengeinstitutterService } from '../pengeinstitutter.service';
import { KeepScrollPositionDirective } from '@shared/directives/keep-scroll-position.directive';

@Component({
  selector: 'app-pi-result',
  imports: [DatePipe, TableRowDirective, TableModule, DatePipe, KeepScrollPositionDirective],
  templateUrl: './pi-result.component.html',
  styleUrl: './pi-result.component.css'
})
export class PiResultComponent {
  piService = inject(PengeinstitutterService);
  data = this.piService.datasource.data;

  onRowSelect(e: TableRowSelectEvent) {
    this.piService.selectPiResultRow(e.data);
  }
}
